<style scoped>
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5) !important;
  border-color: rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 768px) {
  .btn-login {
    width: 100%;
    border-radius: 0px !important;
  }
}
@media only screen and (min-width: 1024px) {
  .btn-login {
    width: 150px;
  }
}
.mega-dropdown {
  position: static !important;
}

.mega-dropdown-menu {
  padding: 20px 0px;
  width: 50%;
  box-shadow: none;
  -webkit-box-shadow: none;
  /* max-width: 1300px; */
  margin: 0 auto;
}

.mega-dropdown-menu > li > ul {
  padding: 0;
  margin: 0;
}

.mega-dropdown-menu > li > ul > li {
  list-style: none;
}

.mega-dropdown-menu > li > ul > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.428571429;
  color: #999;
  white-space: normal;
}

.mega-dropdown-menu > li ul > li > a:hover,
.mega-dropdown-menu > li ul > li > a:focus {
  text-decoration: none;
  color: #444;
  background-color: #f5f5f567;
}

.mega-dropdown-menu .dropdown-header {
  color: #428bca;
  font-size: 18px;
  font-weight: bold;
}

.mega-dropdown-menu form {
  margin: 3px 20px;
}

.mega-dropdown-menu .form-group {
  margin-bottom: 3px;
}
</style>
<template>
  <div>
    <b-navbar toggleable="lg" type="light" class="fixed-top navbar-primary">
      <b-container fluid>
        <b-navbar-brand to="/"
          ><b-img
            src="/img/logo-text.svg"
            fluid
            alt="Responsive image"
            class="indah-brand"
          ></b-img
        ></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" class="mr-2 text-white">
          <template #default="{ expanded }">
            <b-icon v-if="expanded" icon="x"></b-icon>
            <b-icon v-else icon="list"></b-icon>
          </template>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
        <b-icon v-b-toggle.sidebar-backdrop icon="menu-button-wide"></b-icon>
          </b-navbar-nav>
          <b-navbar-nav
            v-if="this.$store.getters['auth/isAuthenticated']"
            class="ml-auto"
          >
            <b-dropdown
              right
              button-class="blank"
              variant="logout"
              :text="$store.getters['auth/user'].name"
            >
              <b-dropdown-item to="/logout">Keluar</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>
          <b-navbar-nav v-else class="ml-auto">
            <b-button variant="login" size="sm" type="submit" to="/login"
              >Masuk <b-icon icon="box-arrow-in-right"></b-icon
            ></b-button>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <b-sidebar
      id="sidebar-backdrop"
      title="Sidebar with backdrop"
      backdrop-variant="dark"
      backdrop
      shadow
    >
      <div class="px-3 py-2">
        haha
      </div>
    </b-sidebar>
  </div>
</template>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      openMegaMenu: false
    };
  },
  components: {},
  methods: {
    show() {
      if (this.$store.getters["mega_menu/isShow"]) {
        this.$store.dispatch("mega_menu/hide");
      } else {
        this.$store.dispatch("mega_menu/show");
      }
    },
    closeEvent: function() {
      this.$store.dispatch("mega_menu/hide");
    }
  }
};
</script>
